module.exports = __webpack_public_path__ + "static/media/UneteTiempo.8abbedb9.svg";